import api from "@/services/apiService"

class LottoService {

  getResult(date) {
    return new Promise((resolve, reject) => {
      api.get('result' + (date ? '/'+date : ''))
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        });
    });
  }

}

export default new LottoService();
